import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">吃瓜资讯</h2>
          <p className="section-subtitle">最新最热的娱乐八卦资讯，每日持续更新中</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.slice(0, 6).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[8/5] object-cover group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-primary-50 text-primary-700 px-2 py-0.5 rounded-full font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {item.description}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次围观</span>
                </div>
              </div>
            </div>
          ))}
          {cardItems[6] && (
            <div
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col lg:col-span-3"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-1/2 relative overflow-hidden">
                  <img
                    src={cardItems[6].image}
                    alt={cardItems[6].title}
                    className="w-full aspect-video md:aspect-auto md:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="800"
                    height="500"
                  />
                </div>
                <div className="md:w-1/2 p-5 md:p-6 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs bg-primary-50 text-primary-700 px-2 py-0.5 rounded-full font-medium">
                      {cardItems[6].tag}
                    </span>
                    <span className="text-xs text-foreground-400">{cardItems[6].date}</span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3">
                    {cardItems[6].title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                    {cardItems[6].description}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{cardItems[6].views} 次围观</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}